import { Shimmer } from '@components';

import { Container, Title, Head } from './Documents.styles';

export const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 22, width: 22, borderRadius: 4 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

export const DocumentsLoading = () => {
  return (
    <Container>
      <Head>
        <Title>Documents</Title>
      </Head>

      <Shimmer
        style={{
          height: 52,
          width: '100%',
          borderRadius: 4,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <Shimmer
        style={{
          height: 52,
          width: '100%',
          borderRadius: 4,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <Shimmer
        style={{
          height: 52,
          width: '100%',
          borderRadius: 4,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};
